import { render } from "./SliderTestimonials.vue?vue&type=template&id=4ad76321&scoped=true"
import script from "./SliderTestimonials.vue?vue&type=script&lang=js"
export * from "./SliderTestimonials.vue?vue&type=script&lang=js"

import "./SliderTestimonials.vue?vue&type=style&index=0&id=4ad76321&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ad76321"]])

export default __exports__